($ => {
  Drupal.behaviors.testimonialSlick = {
    attach(context) {
      var rev = $('.js-testimonial-content', context);
      if (!rev || !rev.length) {
        return;
      }
      rev.once('slick-init').on('init', function(event, slick, currentSlide) {
        if (!slick.$slides || !slick.$slides.length) {
          return;
        }
        var
          cur = $(slick.$slides[slick.currentSlide]),
          last = $(slick.$slides[slick.slideCount - 1]),
          next = cur.next(),
          next2 = cur.next().next(),
          next3 = cur.next().next().next(),
          prev = cur.prev(),
          prev2 = cur.prev().prev(),
          prev3 = cur.prev().prev().prev();
        prev.addClass('slick-sprev');
        next.addClass('slick-snext');
        prev2.addClass('slick-sprev2');
        prev3.addClass('slick-sprev3');
        next2.addClass('slick-snext2');
        next3.addClass('slick-snext3');
        cur.removeClass('slick-snext').removeClass('slick-sprev').removeClass('slick-snext2').removeClass('slick-sprev2').removeClass('slick-snext3').removeClass('slick-sprev3');
        slick.$prev = prev;
        slick.$next = next;
      }).once('slick-beforechange').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        if (!slick.$slides || !slick.$slides.length) {
          return;
        }
        var
          cur = $(slick.$slides[nextSlide]),
          next = cur.next(),
          next2 = cur.next().next(),
          next3 = cur.next().next().next(),
          prev = cur.prev(),
          prev2 = cur.prev().prev(),
          prev3 = cur.prev().prev().prev();
        slick.$prev.removeClass('slick-sprev');
        slick.$next.removeClass('slick-snext');
        slick.$prev.prev().removeClass('slick-sprev2');
        slick.$next.next().removeClass('slick-snext2');
        slick.$prev.prev().prev().removeClass('slick-sprev3');
        slick.$next.next().next().removeClass('slick-snext3');
        prev.addClass('slick-sprev');
        next.addClass('slick-snext');
        prev2.addClass('slick-sprev2');
        next2.addClass('slick-snext2');
        prev3.addClass('slick-sprev3');
        next3.addClass('slick-snext3');
        slick.$prev = prev;
        slick.$next = next;
        cur.removeClass('slick-next').removeClass('slick-sprev').removeClass('slick-next2').removeClass('slick-sprev2').removeClass('slick-next3').removeClass('slick-sprev3');
      });

      rev.once('slick_carousel').slick({
        speed: 1000,
        arrows: true,
        dots: true,
        focusOnSelect: true,
        prevArrow: '<button class="slick-prev"> prev</button>',
        nextArrow: '<button class="slick-next"> next</button>',
        infinite: true,
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '0',
        swipe: true,
        responsive: [
          {
            breakpoint: 720,
            settings: {
              dots: false,
            }
          },
        ],
        customPaging: function(slider, i) {
          return '';
        }
      });

    },
  };

})(jQuery);